(function(){
  var VARIANT_ID = 52350994678042;
  var THRESHOLD = 16000; // RM160.00 in cents, subtotal excl. shipping

  function findGift(cart){
    for (var i=0;i<cart.items.length;i++){
      if (cart.items[i].variant_id === VARIANT_ID) return cart.items[i];
    }
    return null;
  }
  function eligibleSubtotal(cart){
    var g = findGift(cart);
    return cart.total_price - (g ? g.final_line_price : 0);
  }
  function getAttr(cart, key){
    return cart.attributes ? cart.attributes[key] : undefined;
  }
  function updateAttributes(attrs){
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: attrs })
    });
  }
  function addGift(){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
    });
  }
  function removeGift(cart){
    var g = findGift(cart);
    if(!g) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ id: g.key, quantity: 0 })
    });
  }

  // Returns a Promise<boolean> -- true if it mutated the cart (caller should re-fetch/re-render)
  function syncGift(cart){
    var gift = findGift(cart);
    var eligible = eligibleSubtotal(cart) >= THRESHOLD;
    var optedOut = getAttr(cart, 'vc_gift_opt_out') === 'true';
    var offered = getAttr(cart, 'vc_gift_offered') === 'true';

    if (!gift) {
      if (eligible) {
        if (optedOut) return Promise.resolve(false);
        if (offered) {
          // was added before, now missing while still eligible => customer explicitly removed it
          return updateAttributes({ vc_gift_opt_out: 'true' }).then(function(){ return true; });
        }
        return addGift().then(function(){
          return updateAttributes({ vc_gift_offered: 'true' });
        }).then(function(){ return true; });
      }
      if (offered || optedOut) {
        return updateAttributes({ vc_gift_offered: '', vc_gift_opt_out: '' }).then(function(){ return true; });
      }
      return Promise.resolve(false);
    }

    if (!eligible) {
      return removeGift(cart).then(function(){
        return updateAttributes({ vc_gift_offered: '', vc_gift_opt_out: '' });
      }).then(function(){ return true; });
    }

    return Promise.resolve(false);
  }

  window.VC_GIFT = { syncGift: syncGift, VARIANT_ID: VARIANT_ID, THRESHOLD: THRESHOLD };
})();
